// Local additions to the rules index for content the upstream
// rules-index-export.json doesn't cover yet.
//
// Keys are lowercased rule/unit/item names (same normalization as rulesMap).
// `url` points at the OWR page (tow.whfb.app/<url>). The Hordes of Chaos
// pages exist on the OWR beta but not production yet — the eye button will
// show a not-found page until OWR ships them, then start working without
// any change here. Delete entries once upstream's index export includes them.

export const localRulesAdditions = {
  // Hordes of Chaos (Warriors of Chaos Army of Infamy) magic items
  "sword of reaving": { url: "magic-item/sword-of-reaving", page: "AJ:WoC" },
  "flail of wrecks": { url: "magic-item/flail-of-wrecks", page: "AJ:WoC" },
  "grim verdict": { url: "magic-item/grim-verdict", page: "AJ:WoC" },
  "hunter's scorn": { url: "magic-item/hunters-scorn", page: "AJ:WoC" },
  "armour of dark faith": {
    url: "magic-item/armour-of-dark-faith",
    page: "AJ:WoC",
  },
  "scale of false promise": {
    url: "magic-item/scale-of-false-promise",
    page: "AJ:WoC",
  },
  "mantle of drifting shadow": {
    url: "magic-item/mantle-of-drifting-shadow",
    page: "AJ:WoC",
  },
  "amulet of spell attraction": {
    url: "magic-item/amulet-of-spell-attraction",
    page: "AJ:WoC",
  },
  "periapt of soul exchange": {
    url: "magic-item/periapt-of-soul-exchange",
    page: "AJ:WoC",
  },
  "the banner of the dark heart": {
    url: "magic-item/the-banner-of-the-dark-heart",
    page: "AJ:WoC",
  },
  "standard of the fell warrior": {
    url: "magic-item/standard-of-the-fell-warrior",
    page: "AJ:WoC",
  },
  "ring of doom": { url: "magic-item/ring-of-doom", page: "AJ:WoC" },
  "daemon-blooded steed": {
    url: "magic-item/daemon-blooded-steed",
    page: "AJ:WoC",
  },
  "elixir of power": { url: "magic-item/elixir-of-power", page: "AJ:WoC" },
  "rod of might": { url: "magic-item/rod-of-might", page: "AJ:WoC" },
  "scroll of invocation": {
    url: "magic-item/scroll-of-invocation",
    page: "AJ:WoC",
  },
  "infernal familiar": {
    url: "magic-item/infernal-familiar",
    page: "AJ:WoC",
  },

  // New Hordes of Chaos units (no stats until OWR publishes profiles —
  // do not invent statlines here)
  "chieftain of ruin": { url: "unit/chieftain-of-ruin", page: "AJ:WoC" },
};
